// Duplicated from leave Quote
import { CLAIMS_CLAIMDETAIL_RESET } from '@/store/types'
import { recordLockMixin } from '@/mixins/common/recordLockMixin'
export const leaveClaim = {
  data() {
    return {
      routeTo: undefined,
      // Skip prompt to use internally only
      skipPrompt: false,
      promptLeave: false
    }
  },
  methods: {
    doExit() {
      try {
        // AR: OS-660 Unlock Record upon exit 29-Jan-2021
        this.unlockRecord(this.commonInfo.clmNo, 'CLM')
        this.$store.dispatch('sendNotification', this.$store.state.claims.clmPendExistList, { root: true })
        this.$store.dispatch('printClaimDocumentClaimEntry')
        this.skipPrompt = true
        this.$store.commit(CLAIMS_CLAIMDETAIL_RESET)
        this.$router.push(this.routeTo.path)
      } catch (e) {}
    },
    async doSaveAndExit() {
      // AR: OS-660 Unlock Record upon exit 29-Jan-2021
      this.unlockRecord(this.commonInfo.clmNo, 'CLM')

      // Emit saving event on global event bus
      // Each Claim page should listen to this and do partial Submit and save
      this.$root.$emit('saveClaim', true)
    }
  },
  // If user tries to leave this quotation, it will prompt leave message
  beforeRouteLeave(to, from, next) {
    if (this.skipPrompt) {
      next()
    } else {
      if (this.$store.state.claims.claimDetail.promptWhenExit) {
        this.routeTo = to
        this.promptLeave = true
        next(false)
      } else {
        next()
      }
    }
  },
  created() {
    this.$root.$on('leaveClaim', () => {
      this.doExit()
    })
    // AR: Initialize CommonUtil Menu 29-Jan-2021
    this.initCommonUtilMenu()
  },
  mixins: [recordLockMixin],
  beforeDestroy() {
    this.$root.$off('leaveClaim')
  }
}
